/* @flow */
import invariant from 'invariant';
import * as React from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';

import AuthActions from 'auth/AuthActions';
import Button from 'components/Button';
import Buttons from 'components/Buttons';
import Device from 'entities/Device';
import errorLogger from 'utils/errorLogger';
import Field from 'components/Field';
import Heading from 'components/Heading';
import Input from 'components/Input';
import Link from 'components/Link';
import ToastActions from 'actions/ToastActions';

import 'styles/utilities.scss';

class ConfirmPhone extends React.Component<$FlowFixMeProps, $FlowFixMeState> {
  static propTypes = {
    uid: PropTypes.string.isRequired,
    onSuccess: PropTypes.func,
    onGoBack: PropTypes.func,
  };

  static contextTypes = {
    router: PropTypes.object.isRequired,
  };

  state = {
    isValidCode: false,
    verifying: false,
  };

  componentDidMount() {
    this.sendSMSConf(() => {}, () => ToastActions.showErrorToast('Error sending the code'));
  }

  onCodeChange = (event: SyntheticEvent<>) => {
    // $FlowFixMe
    const isValidCode = event.target.value.match(/^\d{4}$/);
    this.setState({ isValidCode });
  };

  onContinue = () => {
    this.setState({ verifying: true });
    const onError = () => {
      this.setState({ verifying: false });
      ToastActions.showErrorToast('Error verifying your phone.');
    };
    const onSuccess = ({ token }) => {
      AuthActions.accessTokenSignIn(token)
        .then(() => {
          if (this.props.onSuccess) {
            this.props.onSuccess();
          } else {
            this.context.router.push('/join/role_picker');
          }
        })
        .catch(errorLogger('ConfirmPhone sign in failed'));
    };

    const node = ReactDOM.findDOMNode(this.refs.code);
    invariant(
      node instanceof window.HTMLElement,
      'ConfirmPhone findDOMNode returned non HTMLElement'
    );
    const code = node.value;
    return Device.createOutboundDevice(this.props.uid, code).then(onSuccess, onError);
  };

  sendSMSConf = (onSuccess?: Function, onError?: Function) => {
    return Device.outboundVerify(this.props.uid).then(() => {
      if (onSuccess) {
        onSuccess();
      }
    }, onError);
  };

  resendSMSConf = () => {
    const onError = () => ToastActions.showErrorToast('Error sending the code');
    const onSuccess = () => ToastActions.showSuccessToast('Code successfully resent');
    return this.sendSMSConf(onSuccess, onError);
  };

  render() {
    return (
      <div className="ConfirmPhone">
        <Heading>Enter your code</Heading>
        <p className="block">
          Please enter the 4-digit code sent to you.
          <br />
          Didn’t receive the code? <Link onClick={this.resendSMSConf}>Resend</Link>
        </p>
        <Field>
          <Input
            ref="code"
            autofocus
            placeholder="0000"
            maxLength="4"
            onChange={this.onCodeChange}
            size="large"
          />
        </Field>
        <Buttons axis="y">
          <Button
            disabled={!this.state.isValidCode || this.state.verifying}
            onClick={this.onContinue}
            full>
            Continue
          </Button>
          {this.props.onGoBack && (
            <Button level="text" onClick={this.props.onGoBack}>
              Go back
            </Button>
          )}
        </Buttons>
      </div>
    );
  }
}
export default ConfirmPhone;
